
import React, { useState, useEffect } from "react";
import { useParams, Link,useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "../../Product/style/productGraid.css";
import "../../Product/style/categoryList.css";
import "../../Product/style/GridModal.css";
import ModalBoxPopup from "../../Product/component/ModalBoxPopup";
import GridListingData from "../../Product/pages/GridListingData";
import Searchgrid from "../../../Component/search/Searchgrid";
import noproduct from "../../../assets/images/Noproduct-Found.png";
import { getcategory } from "../service/category.service";
import { getSearchProductDetails } from "../service/productdetails.service";
import { useDispatch, useSelector } from "react-redux";
import { addToWishlist, fetchWishlist, } from "../../Pages/wishlist/redux/wishlistSlice";
import Breadcrumb from "../../../Component/breadcrumb/Breadcrumb";
import { Toaster, toast } from "react-hot-toast";
import { useSearchParams } from "react-router-dom";

function SearchGridPage() {
  const { slug } = useParams();
    const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [activeWishlist, setActiveWishlist] = useState({});
  const { wishlist = [] } = useSelector(
    (state) => state.wishlist || {}
  );

  // =========================================================
  // USER ID
  // =========================================================

  const loginUser = JSON.parse(
    localStorage.getItem("userData") || "{}"
  );

  const userId =
    Number(localStorage.getItem("userId")) ||
    Number(loginUser?.id) ||
    Number(loginUser?.user_id) ||
    1;

  // =========================================================
  // CUSTOMER ID
  // =========================================================

  const selectedCustomer = JSON.parse(
    localStorage.getItem("selectedCustomer") || "{}"
  );

  const customerId =
    Number(
      selectedCustomer?.id ||
      selectedCustomer?.customerId ||
      selectedCustomer?.customer_id
    ) || null;

  // =========================================================
  // GET PRODUCT LISTING ID
  // =========================================================

  const getProductListingId = (item) => {
    if (!item) return null;
    const id =
      item?.product_listing_id ||
      item?.sizes?.[0]?.product_listing_id ||
      item?.sizes?.[0]?.product_id ||
      item?.product_id ||
      item?.id;

    return id ? Number(id) : null;
  };

  // =========================================================
  // LOAD WISHLIST
  // =========================================================

  useEffect(() => {
    if (!userId || !customerId) {
      return;
    }
    dispatch(
      fetchWishlist({
        userId,
        customerId,
      })
    );
  }, [dispatch, userId, customerId]);

  // =========================================================
  // CHECK PRODUCT WISHLIST
  // =========================================================

const isWishlist = (item) => {
  const productListingId = getProductListingId(item);

  if (!productListingId) {
    return false;
  }

  // Click ke baad immediately active
  if (activeWishlist[productListingId]) {
    return true;
  }

  // API se already wishlist me hai
  if (item?.is_wishlist === true) {
    return true;
  }

  return wishlist.some((row) => {
    const wishlistId =
      Number(
        row?.product_listing_id ||
        row?.product_id ||
        row?.sizes?.[0]?.product_listing_id ||
        row?.sizes?.[0]?.product_id ||
        row?.id
      ) || null;

    return wishlistId === productListingId;
  });
};
  // =========================================================
  // ADD WISHLIST
  // =========================================================

const handleWishlist = async (item) => {
  if (!customerId) {
    toast.error("Customer ID not found");
    return;
  }

  const productListingId = getProductListingId(item);

  if (!productListingId) {
    console.error("Product listing ID not found", item);
    toast.error("Product listing ID not found");
    return;
  }

  setActiveWishlist((prev) => ({
    ...prev,
    [productListingId]: true,
  }));

  const payload = {
    user_id: Number(userId),
    customer_id: Number(customerId),
    product_listing_id: Number(productListingId),
  };

  try {
    const response = await dispatch(
      addToWishlist(payload)
    ).unwrap();

    console.log("WISHLIST API RESPONSE =", response);

    toast.success(
      response?.message || "Product added to wishlist"
    );

    // API se latest wishlist
    dispatch(
      fetchWishlist({
        userId,
        customerId,
      })
    );
  } catch (error) {
    console.error("WISHLIST API ERROR =", error);
    setActiveWishlist((prev) => {
      const updated = { ...prev };
      delete updated[productListingId];
      return updated;
    });

    toast.error(
      error?.message ||
      error?.data?.message ||
      "Failed to add product to wishlist"
    );
  }
};

  // =========================================================
  // LOAD PRODUCT DATA
  // =========================================================
const includeComingSoon = Number(searchParams.get("includeComingSoon") || 0);
const source = searchParams.get("source") || 'quality';
const p_quality_slug = searchParams.get("sourceQuery") || null;
const p_search_text = searchParams.get("q") || null;

useEffect(() => {
  const checkDevice = () => {
    if (!p_search_text) return;

    const path =
      window.innerWidth > 768
        ? "/search"
        : "/m/search";
    console.log(path);
    navigate(
      `${path}?q=${encodeURIComponent(
        p_search_text
      )}&sourceQuery=${encodeURIComponent(p_quality_slug)}`,
      { replace: true }
    );
  };

  checkDevice();

  window.addEventListener("resize", checkDevice);

  return () => {
    window.removeEventListener("resize", checkDevice);
  };
}, [p_search_text, p_quality_slug, slug, navigate]);

useEffect(() => {
  const fetchData = async () => {
    try {
      setLoading(true);

      let data = [];

      if (p_search_text) {
        data = await getSearchProductDetails(p_quality_slug,p_search_text, source, includeComingSoon);
      } else {
        data = await getcategory();
      }

      if (Array.isArray(data)) {
        setProducts(data);
      } else if (Array.isArray(data?.data)) {
        setProducts(data.data);
      } else {
        setProducts([]);
      }
    } catch (error) {
      console.error("PRODUCT API ERROR =", error);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [p_quality_slug,p_search_text,source, includeComingSoon]);
  // =========================================================
  // SEARCH FILTER
  // =========================================================

  const filteredProducts = products.filter((item) => {
    const keyword = search.trim().toLowerCase();

    if (!keyword) {
      return true;
    }
    const design =
      item?.design?.toLowerCase() || "";

    const shade =
      item?.shade?.toLowerCase() || "";

    const designShade =
      `${design} ${shade}`;

    return (
      design.includes(keyword) ||
      shade.includes(keyword) ||
      designShade.includes(keyword)
    );
  });

  // =========================================================
  // MODAL
  // =========================================================

const handleShow = (item) => {
  const originalIndex = products.findIndex(
    (product) =>
      getProductListingId(product) ===
      getProductListingId(item)
  );

  if (originalIndex !== -1) {
    setCurrentIndex(originalIndex);
    setShow(true);
  }
};



  const handleClose = () => {
    setShow(false);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) =>
      prev === 0
        ? products.length - 1
        : prev - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prev) =>
      prev === products.length - 1
        ? 0
        : prev + 1
    );
  };

  // =========================================================
  // BREADCRUMB
  // =========================================================

  /* ============================
     MOBILE REDIRECT
  ============================ */

  useEffect(() => {
  const checkDevice = () => {
    if (window.innerWidth <= 768 && slug) {
      const source = searchParams.get("source") || 'header';
      const includeComingSoon = Number(searchParams.get("includeComingSoon")) || 0;
      navigate(
        `/mobile/${slug}/list?source=${source}&includeComingSoon=${includeComingSoon}`??`/${slug}/list?source=${source}&includeComingSoon=${includeComingSoon}`,
        { replace: true }
      );    
      }
  };
  window.addEventListener("resize", checkDevice);
  checkDevice();
    return () => window.removeEventListener("resize", checkDevice);
  }, [slug, navigate, searchParams]);


  const breadcrumbItems =
    products.length > 0
      ? [
        {
          name: `${p_search_text}`,
          path:p_search_text,
        },
      ].filter((item) => item.name)
      : [];

  // =========================================================
  // SKELETON
  // =========================================================

  const SkeletonCard = () => (
    <div className="col-md-3">
      <div className="box">
        <Skeleton height={200} />
        <div className="mt-2">
          <Skeleton width={60} />
        </div>
      </div>
    </div>
  );

  // =========================================================
  // RETURN
  // =========================================================

  return (
    <>
      {/* BREADCRUMB */}
      <div
        style={{
          background: "#eeeeee",
        }}
      >
        <Breadcrumb
          items={breadcrumbItems}
        />
      </div>
       <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          duration: 3000,
        }}
      />

      {/* SEARCH */}

      <Searchgrid
        totalProducts={products.length}
        search={search}
        setSearch={setSearch}
        item={products[0] || {}}
        slug={slug}
        loading={loading}
        source={source}
        includeComingSoon={includeComingSoon}
      />

      {/* PRODUCT GRID */}
      <section className="Category-Graid">
        <div className="container">
          <div className="row row-cols-2 row-cols-xl-5 g-3">
            {loading ? (
              Array.from({ length: 5 }).map(
                (_, index) => (
                  <SkeletonCard
                    key={index}
                  />
                )
              )
            ) : filteredProducts.length > 0 ? (
              filteredProducts.map(
                (item, index) => {
                  const productListingId = getProductListingId(item);
                  const wishlistActive = isWishlist(item);
                  return (
                    <div
                      className="col-md-3"
                      key={
                        productListingId ||
                        `${item?.design}-${item?.shade}-${index}`
                      }
                    >
                      <div className="box">

                        {/* IMAGE */}
                        <div
                          className="boximgaes"
                         >
                          <span onClick={() => handleShow(item)}>
                          <img
                            src={item?.image_path}
                            alt={
                              item?.design ||
                              "Product"
                            }
                            style={{
                              cursor:
                                "pointer",
                              width: "100%",
                            }}
                          />
                          </span>
                      <Link
                          className="text-yellow"
                          onClick={(e) => {
                            e.preventDefault();
                            handleWishlist(item);
                          }}
                        >
                          <i
                            className={
                              wishlistActive
                                ? "bi bi-heart-fill text-danger"
                                : "bi bi-heart"
                            }
                          />
                        </Link>
                        </div>

                        {/* TITLE + WISHLIST */}

                        <div className="box-title d-flex align-items-center justify-content-center mt-2">
                          <p>
                            {
                              item?.designshade
                            }
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                }
              )

            ) : (

              /* NO PRODUCT */

              <div className="row w-100">
                <div className="col-md-12 text-center py-5">
                  <img
                    src={noproduct}
                    alt="No product"
                    style={{
                      width: "140px",
                      margin: "0 auto",
                    }}
                  />
                  <h4>
                    No products found.
                  </h4>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* PRODUCT MODAL */}

      {!loading &&
        products.length > 0 && (
          <GridListingData
            Modal={Modal}
            show={show}
            handleShow={handleShow}
            handleClose={handleClose}
            handlePrev={handlePrev}
            Button={Button}
            Product={products}
            currentIndex={currentIndex}
            handleNext={handleNext}
            ModalBoxPopup={
              ModalBoxPopup
            }
            setCurrentIndex={
              setCurrentIndex
            }
          />
        )}
    </>
  );
}
export default SearchGridPage;

